import React from 'react';
import { GHLink } from '../types/types';

interface CardLinkProps {
	link: GHLink;
}

const CardLink: React.FC<CardLinkProps> = ( { link } ) => {
	const { id, icon, label, url, extraLink } = link;

	if ( extraLink ) {
		return (
			<div className="c-guided-help__resources">
				<div id={id} className="a-card-cta">
					<div className={`a-card-cta__icon ${ icon }`} aria-hidden="true"></div>
					<div className="a-card-cta__label a-card-cta__label--small">
						<div dangerouslySetInnerHTML={{ __html: label }} />
						<div>
							<a
								className="btn btn--tertiary"
								href={extraLink.url}
								data-link-click
							>
								{extraLink.label}
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
	return (
		<div className="c-guided-help__resources">
			<a id={id} className="a-card-cta" href={url} data-link-click>
				<div className={`a-card-cta__icon ${ icon }`} aria-hidden="true"></div>
				<div className="a-card-cta__label" dangerouslySetInnerHTML={{ __html: label }} />
			</a>
		</div>
	);
};

export default CardLink;
